import React from 'react';
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import ProjectCard from "./Project/ProjectCard"
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';

import {
  loadProjects,
} from 'actions/MyProjects';


class Project {
  constructor(nome, data) {
    this.nome = nome;
    this.data = data;
  }
}

class Sample extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      myList: []
    }

    var p1 = new Project('3', 'H');
    var p2 = new Project('4', 'H');

    this.state.myList.push(p1)
    this.state.myList.push(p2)
  }

  componentDidMount() {

    console.log("############ SAMPLE- DID mount");
    const userID = this.props.authUser;
    this.props.loadProjects(userID);
  }

  render() {


    if (this.props.myProjectList != '') {
      return (
        <div
          style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        ><ProjectCard /></div>

      );
    } else {
      return (

        <div
        style={{
          position: 'absolute', left: '50%', top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >Caricamento</div>



      );
    }

  }
}

const mapStateToProps = ({ auth, myProjects }) => {
  const { authUser } = auth;
  const { myProjectList } = myProjects;
  return { authUser, myProjectList }
};

export default connect(mapStateToProps, {
  loadProjects,
})(Sample);